import { Clear } from '@mui/icons-material'
import {
  Box,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import { SealType } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { BinIcon } from '@tom-ui/ui'
import _ from 'lodash'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { OrderSealType } from '../stores/OrderSealsSubFormStore'

export const SealWithTypeSelection: FC<{
  index: number
  seal: OrderSealType
  isSmallView?: boolean
  onDelete?: () => void
  //This is provisory to work with react forms and should be removed once all the forms are migrated
  onChange?: () => void
}> = observer(({ index, seal, isSmallView, onChange, onDelete }) => {
  const { t } = useTranslate()

  const isNewSeal = computed(() => seal.isNewSeal.value).get()
  const isMissingSeal = computed(() => seal.isMissingSeal.value).get()

  return (
    <>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography variant='subtitle1'>{`Seal ${index + 1}`}</Typography>
        <IconButton color='default' onClick={() => onDelete?.()}>
          <BinIcon />
        </IconButton>
      </Box>
      <Grid container alignItems='center' spacing={2}>
        <Grid sx={{ display: 'flex', gap: 1 }} size={12}>
          <Chip
            label={t('existingSeal', 'Existing seal')}
            onClick={() => {
              seal.isNewSeal.setValue(false)
              seal.isMissingSeal.setValue(false)
              onChange?.()
            }}
            color={!isNewSeal && !isMissingSeal ? 'secondary' : 'default'}
          />

          <Chip
            label={t('newSeal', 'New seal')}
            onClick={() => {
              seal.isNewSeal.setValue(true)
              seal.isMissingSeal.setValue(false)
              onChange?.()
            }}
            color={isNewSeal && !isMissingSeal ? 'secondary' : 'default'}
          />

          <Chip
            label={t('missing', 'Missing')}
            onClick={() => {
              seal.isNewSeal.setValue(false)
              seal.isMissingSeal.setValue(true)
              onChange?.()
            }}
            color={isMissingSeal && !isNewSeal ? 'secondary' : 'default'}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            sm: isSmallView ? 12 : 6,
          }}
        >
          <FormControl fullWidth>
            <InputLabel id='select-seal-type-label'>{t('sealType', 'Seal type')}</InputLabel>
            <Select
              id='select-seal-type'
              labelId='select-seal-type-label'
              {...seal.type.props}
              defaultValue={seal.type.value}
              label={t('sealType', 'Seal type')}
              onChange={event => {
                seal.type.onChange(event)
                onChange?.()
              }}
              endAdornment={
                seal.type.value && (
                  <InputAdornment sx={{ marginRight: '10px' }} position='end'>
                    <IconButton
                      size='small'
                      onClick={() => {
                        seal.type.setValue('')
                        onChange?.()
                      }}
                    >
                      <Clear />
                    </IconButton>
                  </InputAdornment>
                )
              }
            >
              {Object.values(SealType).map(type => (
                <MenuItem key={type} value={type}>
                  {t(_(type).lowerFirst())}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: isSmallView ? 12 : 6,
          }}
        >
          <TextField
            sx={{ width: '100%' }}
            type='text'
            label={t('sealNo', 'Seal no')}
            {...seal.number.props}
            onChange={event => {
              seal.number.onChange(event)
              onChange?.()
            }}
          />
        </Grid>
      </Grid>
    </>
  )
})
